import { createFileRoute } from '@tanstack/react-router';
import UsersPage from 'src/Administration/UsersPage/UsersPage';

export const Route = createFileRoute('/systemadmin/_layout/users/')({
  component: UsersPage,
});
